export default __webpack_public_path__ + "static/media/2-content.a3120fa8.png";